import { RouteComponentProps } from "@reach/router";
import * as React from "react";
import { Grid } from "@mui/material";
import TokensOverview from "../../components/TokensOverview/TokensOverview";

interface Props extends RouteComponentProps {
    organizationId?: string;
}

function Tokens({ organizationId }: Props) {
    return (
        <Grid container spacing={{ xs: 5, md: 6 }} justifyContent="center">
            <Grid item xs={12}>
                <TokensOverview organizationId={organizationId!} />
            </Grid>
        </Grid>
    );
}

export default Tokens;
